
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

export default function SingleBlogDetail({ blog }) {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            {blog?.contentSections?.length > 0 && blog.contentSections.map((item, key) => {
                if (item.type === "imageText" && item.contentImage && item.contentEditor) {
                    return (
                        <div key={key} className='single-blog-detail-sec inspo-detail-sec d-grid bg-white'>
                            <div className='inspo-detail-items inspo-detail-large-items d-flex justify-center'>
                                {item?.contentImage ?
                                    <div className='inspo-detail-item-img'>
                                        <img src={config.BASE_URL + item.contentImage} alt="inspo-img" />
                                    </div> : <></>}
                                {item?.contentEditor ? <>
                                    <div className='inspo-detail-item-desc' dangerouslySetInnerHTML={{ __html: item.contentEditor.replace(/\n/g, "<br />") }} />

                                </> : <></>}
                            </div>
                        </div>
                    );
                }

                if (item?.type === "editorOnly" && item?.contentEditor) {
                    return (
                        <>{item?.contentEditor ?
                            <div key={key} className='single-blog-detail-sec inspo-detail-sec d-grid bg-white'>
                                <div className='inspo-detail-items d-flex justify-center'>
                                    <div className='inspo-detail-item-desc' dangerouslySetInnerHTML={{ __html: item.contentEditor.replace(/\n/g, "<br />") }} />
                                </div>
                            </div> : <></>}
                        </>
                    );
                }

                if (item.type === "galleryImages" && item.contentGalleryImages?.length > 0) {
                    return (
                        <>{item.contentGalleryImages?.length > 0 ?
                            <div key={key} className='single-blog-detail-sec inspo-detail-sec d-grid bg-white'>
                                <div className='inspo-detail-items d-flex justify-center'>
                                    <div className='single-blog-detail-gallery'>
                                        {item.contentGalleryImages.map((img, index) => (
                                            <img key={index} src={config.BASE_URL + img} alt="inspo-img" />
                                        ))}
                                    </div>
                                </div>
                            </div> : <></>}
                        </>
                    );
                }

                if (item.type === "bannerImage" && item.contentBannerImage?.[0] && item.bannerText) {
                    return (
                        <div
                            key={key}
                            className='blog-banner inspiration-banner-sec position-relative text-white'
                            style={{
                                backgroundImage: `url(${config.BASE_URL + item.contentBannerImage[0]})`,
                            }}
                        >
                            {item?.bannerText ?
                                <div className='inspiration-banner-inner'>
                                    <h3>{item.bannerText}</h3>
                                </div> : <></>
                            }
                        </div>
                    );
                }

                return null; // Return null for sections with missing required fields
            })}

            <div className='single-blog-detail-sec single-blog-detail-botm-sec inspo-detail-sec d-flex flex-column align-center bg-white'>
                {isDesktop && (
                    <div className='main-blog-right'>
                        <h3>keep in the loop</h3>
                        <p>Sign up for our newsletter to keep up.</p>
                        <div className="newsletter-signup">
                            <input type="email" placeholder="email" />
                            <button type="submit" className='sign-up-btn'>Sign up</button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}